import { enumToOptions } from '@app/shared/helpers';
import { NumberOfParticipantsInTheMIP } from '@app/shared/models/contracts/enums/shared-enums';

export const NUMBER_OF_PARTICIPANTS_IN_THE_MIP_OPTIONS = enumToOptions(
  NumberOfParticipantsInTheMIP,
  undefined,
  true
);
